import {
    PRICE_TYPES,
} from "../../../constants/custom-define-type";

export default {
    props: {
        categoryList: {
            type: String,
            default: "",
        },
        user: {
            type: Object,
            default: () => { }
        },
    },
    computed: {
        normalizedCategoryList() {
            if (Array.isArray(this.categoryList)) {
                return this.categoryList;
            }
            return this.categoryList
                .split("\n")
                .map((category) => category.trim())
                .filter((category) => category.length > 0);
        },
    },
    methods: {
        getPrice(priceObject, job) {
            let basePrice = null;
            if (priceObject.is_price_condition) {
                console.log(priceObject)
                const data = this.getObjectToCalculatePrice(this.user, job, priceObject.price_expression, this.selectedDate);
                const condition = this.calculateUserProperty([priceObject.price_condition], data, 'price');
                if (condition && condition.price) {
                    basePrice = Number(condition.price);
                }
            } else if (priceObject.is_price_expession) {
                basePrice = this.getPriceFromExpression(this.user, job, priceObject.price_expression, this.selectedDate);
            } else {
                basePrice = Number(priceObject.price);
            }

            if (basePrice) {
                // Adjustment for holiday
                const adjustInfo = this.getHolidayAdjustment(job, priceObject);
                basePrice = this.getAdjustPrice(basePrice, adjustInfo);
                // Adjustment for surge price
                if (this.$store.getters.turnOnSurgePricing) {
                    basePrice = this.getAdjustPrice(basePrice, priceObject.surge_pricing);
                }
                return basePrice;
            }
            return null;
        },
        getAdjustPrice(basePrice, adjustInfo) {
            if (!adjustInfo || !adjustInfo.type || !adjustInfo.value) {
                return basePrice;
            }
            if (adjustInfo.type === 'Add') {
                return basePrice + adjustInfo.value;
            } else {
                return basePrice * adjustInfo.value;
            }
        },
        /*
        If option is_restrict_time is set for Hourly booking rate
        or PER_TIME_RANGE_CANDIDATE_FEE is set => Use candidate fee
        In other case, candidate_rate will be used.
        */
        calculateCandidateFee(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            let result = 0;
            // Find per time range candidate fee
            const timeRangeCandidatePrice = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.PER_TIME_RANGE_CANDIDATE_FEE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );

            const listHourBookingRate = this.listPrices.filter(
                (price) =>
                    price.type === PRICE_TYPES.HOURLY_BOOKING_RATE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList) &&
                    price.is_restrict_time
            );
            if (!timeRangeCandidatePrice && !listHourBookingRate.length) {
                // Use candidate rate
                return null;
            }

            // Calculate start time and end time
            let startDate = job.date;
            if (!startDate) {
                startDate = this.dateInDjangoFormat(this.selectedDate);
            }

            let endDate = job.end_date;
            if (!endDate) {
                endDate = startDate;
            }

            if (timeRangeCandidatePrice) {
                if (timeRangeCandidatePrice.is_restrict_time) {
                    const listRanges = this.splitTimeRanges(
                        startDate,
                        job.start_time,
                        endDate,
                        job.end_time,
                        timeRangeCandidatePrice.start_time,
                        timeRangeCandidatePrice.end_time
                    );
                    result +=
                        this.getPrice(timeRangeCandidatePrice, job) *
                        listRanges.length;
                } else {
                    result += this.getPrice(timeRangeCandidatePrice, job);
                }
            }

            for (const hourBookingRate of listHourBookingRate) {
                if (hourBookingRate) {
                    const listRanges = this.splitTimeRanges(
                        startDate,
                        job.start_time,
                        endDate,
                        job.end_time,
                        hourBookingRate.start_time,
                        hourBookingRate.end_time
                    );
                    // Calculate total time
                    const totalTime = listRanges
                        .map((range) => this.calculateDurationInHours(range[0], range[1]))
                        .reduce((a, b) => a + b, 0);
                    result +=
                        this.getPrice(hourBookingRate, job) * totalTime;
                }
            }

            const hourlyFeePerAdditionalChild = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.HOURLY_FEE_PER_ADDITIONAL_CHILD &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (
                hourlyFeePerAdditionalChild &&
                job.number_children &&
                Number(job.number_children) > this.numberOfAllowedChildren
            ) {
                const totalTime = this.calculateDurationInHours(
                    startDate + "T" + this.getTimeString(job.start_time),
                    endDate + "T" + this.getTimeString(job.end_time)
                );
                result =
                    result +
                    this.getPrice(hourlyFeePerAdditionalChild, job) *
                    (Number(job.number_children) - this.numberOfAllowedChildren) *
                    totalTime;
            }
            return this.roundNumberTwoDigits(result);
        },
        calculateCandidateRate(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            let result = 0;
            const hourBookingRate = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.HOURLY_BOOKING_RATE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (hourBookingRate) {
                result = this.getPrice(hourBookingRate, job);
            }
            const hourlyFeePerAdditionalChild = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.HOURLY_FEE_PER_ADDITIONAL_CHILD &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (
                hourlyFeePerAdditionalChild &&
                job.number_children &&
                Number(job.number_children) > this.numberOfAllowedChildren
            ) {
                result =
                    result +
                    this.getPrice(hourlyFeePerAdditionalChild, job) *
                    (Number(job.number_children) - this.numberOfAllowedChildren);
            }
            return this.roundNumberTwoDigits(result);
        },
        calculateTravelFee(job) {
            if (!job.city) {
                return;
            }
            if (this.listPrices.length === 0) {
                return;
            }
            const travelFeePrice = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.TRAVEL_FEE &&
                    this.compareTextWithoutPunctuation(job.city, price.location) &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (travelFeePrice) {
                return this.getPrice(travelFeePrice, job);
            }
            return;
        },
        /*
        Calculate number of hours from created time to start time
        */
        calculateLapseCreateTimeToStartTime(job) {
            // Get created time
            let createdTime = new Date();
            if (job.created_date) {
                createdTime = new Date(job.created_date).getTime();
            }
            let startDate = job.date;
            if (!startDate) {
                startDate = this.dateInDjangoFormat(this.selectedDate);
            }
            const startTime = job.start_time ? this.getTimeString(job.start_time) : "00:00:00";
            const startDateTime = new Date(
                startDate + "T" + startTime
            ).getTime();
            return (startDateTime - createdTime) / 3600000; // Diff in hour
        },
        calculateRushFee(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            const diff = this.calculateLapseCreateTimeToStartTime(job);
            const rushFeePrice = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.RUSH_FEE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList) &&
                    diff <= Number(price.hours)
            );
            if (rushFeePrice) {
                return this.getPrice(rushFeePrice, job);
            }
            return;
        },
        calculateCandidateRushFee(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            const diff = this.calculateLapseCreateTimeToStartTime(job);
            const rushFeePrice = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.CANDIDATE_RUSH_FEE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList) &&
                    diff <= Number(price.hours)
            );
            if (rushFeePrice) {
                return this.getPrice(rushFeePrice, job);
            }
            return;
        },
        // The same with client rate
        calculatePricePerHour(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            const agencyRate = this.calculateAgencyFee(job) || 0;
            const candidateRate = this.calculateCandidateRate(job) || 0;

            return this.roundNumberTwoDigits(Number(agencyRate) + Number(candidateRate));
        },
        calculateTotalBookingFee() {
            if (this.listPrices.length === 0) {
                return;
            }
            let totalFee = 0;
            for (const job of this.bookingData) {
                const hourlyAgencyFee = this.listPrices.find(
                    (price) =>
                        price.type === PRICE_TYPES.HOURLY_AGENCY_FEE &&
                        this.isJobMatchPrice(job, price, this.normalizedCategoryList)
                );
                if (!hourlyAgencyFee) {
                    continue;
                }
                let startDate = job.date;
                if (!startDate) {
                    startDate = this.dateInDjangoFormat(this.selectedDate);
                }
                const jobDuration = this.compareDuration(
                    startDate,
                    job.start_time,
                    job.end_date,
                    job.end_time,
                    4
                );
                totalFee +=
                    jobDuration * this.getPrice(hourlyAgencyFee, job);
            }
            return this.roundNumberTwoDigits(totalFee);
        },
        calculateAgencyFee(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            let result = 0;
            const hourlyAgencyFee = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.HOURLY_AGENCY_FEE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (hourlyAgencyFee) {
                result = result + this.getPrice(hourlyAgencyFee, job);
            }

            const hourlyAgencyCommission = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.HOURLY_AGENCY_COMMISSION &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (hourlyAgencyCommission) {
                result =
                    result + this.getPrice(hourlyAgencyCommission, job);
            }
            // Calculate rush hourly fee
            const diff = this.calculateLapseCreateTimeToStartTime(job);
            const rushHourlyFeePrice = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.RUSH_HOURLY_FEE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList) &&
                    diff <= Number(price.hours)
            );
            if (rushHourlyFeePrice) {
                result = result + this.getPrice(rushHourlyFeePrice, job);
            }

            return this.roundNumberTwoDigits(result);
        },
        getPerBookingAgencyFee(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            const listBookingFees = this.listPrices.filter(
                (price) =>
                    price.type === PRICE_TYPES.PER_BOOKING_AGENCY_FEE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (!listBookingFees.length) {
                return;
            }
            for (const bookingFee of listBookingFees) {
                const fee = this.getPrice(bookingFee, job);
                if (fee) {
                    return fee;
                }
            }
            return;
        },
        getPerBookingCandidateFee(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            const listBookingFees = this.listPrices.filter(
                (price) =>
                    price.type === PRICE_TYPES.PER_BOOKING_CANDIDATE_FEE &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (!listBookingFees.length) {
                return;
            }
            for (const bookingFee of listBookingFees) {
                const fee = this.getPrice(bookingFee, job);
                if (fee) {
                    return fee;
                }
            }
            return;
        },
        getTotalDiscount(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            const bookingFee = this.listPrices.find(
                (price) =>
                    price.type === PRICE_TYPES.BOOKING_TOTAL_DISCOUNT &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (!bookingFee) {
                return;
            }

            return this.getPrice(bookingFee, job);
        },
        getHolidayAdjustment(job, price) {
            let jobLocations;
            if (job && job.locations) {
                jobLocations = job.locations;
            } else if (this.user && this.user.locations) {
                jobLocations = this.user.locations;
            }
            const holidays = price.holidays;
            if (!holidays) {
                return null;
            }
            if (!job) {
                return null;
            }
            let startDate = job.date;
            if (!startDate) {
                startDate = this.dateInDjangoFormat(this.selectedDate);
            }
            if (!startDate) {
                return null;
            }
            let startTime = null;
            if (job.start_time) {
                startTime = this.getTimeString(job.start_time);
            }
            for (const holiday of holidays) {
                if (isNaN(holiday.multiplier)) {
                    continue;
                }
                let bookingDay = this.dateInDjangoFormat(startDate);
                // Remove year
                bookingDay = bookingDay.substring(4);
                if (!bookingDay) {
                    continue;
                }
                let match = false;
                for (const date of holiday.dates) {
                    // Check if holiday location is matched
                    if (this.$store.getters.agencyHolidays) {
                        const holidayInfo = this.$store.getters.agencyHolidays.find(holiday => holiday.date === date);
                        if (holidayInfo && holidayInfo.locations && holidayInfo.locations.length) {
                            if (!this.hasCommonElement(holidayInfo.locations, jobLocations)) {
                                continue;
                            }
                        }
                    }
                    if (date.includes(bookingDay)) {
                        match = true;
                        break;
                    }
                }
                if (match) {
                    // Check if time is match
                    if (holiday.startTime) {
                        if (!startTime || (startTime < holiday.startTime)) {
                            continue;
                        }
                    }
                    if (holiday.endTime) {
                        if (!startTime || (startTime > holiday.endTime)) {
                            continue;
                        }
                    }

                    return { value: Number(holiday.multiplier), type: holiday.type };
                }
            }
            return null;
        },
        getAdminFeeOfJob(job, totalFee, priceType = PRICE_TYPES.ADMIN_FEE) {
            if (!totalFee) {
                return;
            }
            if (this.listPrices.length === 0) {
                return;
            }
            const priceItem = this.listPrices.find(
                (price) =>
                    price.type === priceType &&
                    this.isJobMatchPrice(job, price, this.normalizedCategoryList)
            );
            if (!priceItem) {
                return;
            }

            return Number(totalFee) * Number(priceItem.percentage) / 100;
        },
        recalculatePriceOnAssignJob(job, fillerId) {
            return new Promise(async (resolve) => {
                const result = {};
                if (this.$store.getters.isRecalculatePriceOnAssignJob) {
                    // Check to recalculate some fee
                    await this.setMapJobNumberOfMonthOnAssignJob(
                        job,
                        job.date,
                        fillerId
                    );
                    this.$store.getters.listModelRecalculatedWhenAssignJob.forEach((model) => {
                        const jobObj = { ...job, selected_filler_id: fillerId };
                        if (model === 'agency_fee') {
                            result[model] = this.calculateAgencyFee(jobObj);
                        }
                        if (model === 'candidate_rate') {
                            result[model] = this.calculateCandidateRate(jobObj);
                        }
                        if (model === 'client_rate') {
                            let clientRate = 0;
                            const agencyRate = this.calculateAgencyFee(jobObj);
                            const candidateRate = this.calculateCandidateRate(jobObj);
                            if (agencyRate) {
                                clientRate = clientRate + Number(agencyRate);
                            }
                            if (candidateRate) {
                                clientRate = clientRate + Number(candidateRate);
                            }
                            result[model] = clientRate
                        }
                    });
                }
                resolve(result);
            });

        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/bookings/PriceInfoCalculation.js